// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"73":"db9e3979","80":"33197d06","242":"7bc8a509","254":"b0b012c3","508":"4ac95155","519":"9ace9f0f","668":"c3fdbe3e","977":"257532ad","981":"2e6ba43c"}[chunkId] + ".js";
};